import { z } from 'zod';

/**
 * KS 分析 API (`GET /api/ks-analysis/`) のレスポンス 1 行分。
 *
 * BE は単一年度 (`fiscal_year`) を受け取り、前年度 (実績) と当年度 (見込) の
 * 2 年分を 1 つのフラットな配列として返す。各行が `(fiscalYear, analysisAxis, total)`。
 *
 * `analysisAxis` の各フィールドは BE の analysis_axis パラメータが null の場合は
 * すべて null になる（合計行のみ）。
 */
const KsAnalysisModel = z.object({
  fiscalYear: z.number().int(),
  total: z.number().nullable(),
  analysisAxis: z.object({
    id: z.string().uuid().nullable(),
    name: z.string().nullable(),
    parent: z.string().uuid().nullable(),
    sortingCode: z.string().nullable(),
  }),
});

export const KsAnalysisModels = KsAnalysisModel.array();
export type KsAnalysisRow = z.infer<typeof KsAnalysisModel>;
